import React from "react";
import {
  Skeleton,
  Empty,
  Icon,
  Tag,
  message,
  Modal,
  Button,
  Select
} from "antd";

import "./styles.scss";

class List extends React.Component {
  constructor(props) {
    super(props);
  }

  onTagClick = (e, category) => {
    e.stopPropagation();
    const { setCurrentCategory } = this.props;
    const { name, products } = category;

    if (products) setCurrentCategory(name, products);
  };

  //  taken from https://code.i-harness.com/en/q/54d7b8
  shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt((R * (100 + percent)) / 100);
    G = parseInt((G * (100 + percent)) / 100);
    B = parseInt((B * (100 + percent)) / 100);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

    return "#" + RR + GG + BB;
  }

  render() {
    const { data, colors, activeIndex, setActiveCell } = this.props;
    return (
      <div className="list">
        {data.map((item, index) => (
          <div key={index} className="list-item" onClick={() => setActiveCell(index)}>
            <div className="circle-name">
              <div
                className={`circle ${
                  index === activeIndex ? "circle-active" : ""
                }`}
                style={{
                  backgroundColor: colors[index % colors.length]
                }}
              />
              <div
                className={`name ${index === activeIndex ? "name-active" : ""}`}
              >
                {item.name}
              </div>
            </div>
            <div
              className={`cost ${index === activeIndex ? "cost-active" : ""}`}
            >
              <Tag
                color={this.shadeColor(colors[index % colors.length], -30)}
                onClick={e => this.onTagClick(e, item)}
              >
                {item.cost}
              </Tag>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default List;
